export const ATTACHED_DOCUMENT_MAX_MB = 4;
export const ATTACHED_DOCUMENT_ACCEPT = '.pdf,.jpg,.jpeg,.png';
export const ATTACHED_DOCUMENT_MIME_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png'
];
export const ATTACHED_DOCUMENT_UPLOAD_ERROR = 'Oops! Something went wrong';
export const ATTACHED_DOCUMENT_TABLE_DISPLAY_MAX_LENGTH = 20;
